import * as React from 'react'
import { OverviewCard } from './overview-card'
import { Sparkle } from '@phosphor-icons/react'

export type SkillFilter = 'all' | 'hard' | 'soft' | 'declared' | 'inferred'

export type OverviewCardsProps = {
  counts: {
    all: number
    hard: number
    soft: number
    declared: number
    inferred: number
  }
  selectedFilter: SkillFilter
  onFilterClick: (filter: SkillFilter) => void
}

export const OverviewCards = (props: OverviewCardsProps) => {
  const { counts, selectedFilter, onFilterClick } = props

  return (
    <div className="flex gap-3 bg-gray-50 text-progression-green items-center p-3 overflow-x-auto">
      <Sparkle size={20} weight="fill" className="flex-shrink-0" />
      Quick filters
      <OverviewCard
        description="All skills"
        onClick={() => onFilterClick('all')}
        selected={selectedFilter === 'all'}
        value={counts.all}
      />
      <OverviewCard
        description="Hard skills"
        onClick={() => onFilterClick('hard')}
        selected={selectedFilter === 'hard'}
        value={counts.hard}
      />
      <OverviewCard
        description="Soft skills"
        onClick={() => onFilterClick('soft')}
        selected={selectedFilter === 'soft'}
        value={counts.soft}
      />
      <OverviewCard
        description="Declared skills"
        onClick={() => onFilterClick('declared')}
        selected={selectedFilter === 'declared'}
        value={counts.declared}
      />
      <OverviewCard
        description="Inferred skills"
        onClick={() => onFilterClick('inferred')}
        selected={selectedFilter === 'inferred'}
        value={counts.inferred}
      />
    </div>
  )
}
